var _path, _path2, _path3, _path4, _path5, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopsicle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 63,
    viewBox: "0 0 15 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.77896 45.4421V61.3718C5.77896 63.2257 8.63158 63.2257 8.63158 61.3718V45.4421C8.63158 43.5883 5.77896 43.5883 5.77896 45.4421Z",
    fill: "#621C00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9919 10.1255C13.7733 10.2653 12.5639 10.4143 11.3453 10.5261C7.79109 10.8521 4.13531 11.0478 0.636466 10.5075L0.368744 22.8879H14.9919V10.1162V10.1255Z",
    fill: "#FD9CAE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3436 10.5267C12.5622 10.4149 13.7808 10.2658 14.9901 10.1261V9.08274C14.9901 4.90002 11.6298 0 7.49393 0C3.3581 0 0.680882 4.20135 0.680882 8.38407L0.63472 10.5173C4.13356 11.0577 7.78935 10.862 11.3436 10.536V10.5267Z",
    fill: "#FED6D6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.15463 35.0077C4.79129 35.166 2.40949 35.343 0.0923164 35.7995L0 40.1685C0 44.3512 3.36036 47.7328 7.4962 47.7328C11.632 47.7328 14.9924 44.3419 14.9924 40.1685V34.9983C12.3983 34.6537 9.75799 34.8307 7.1454 34.9983L7.15463 35.0077Z",
    fill: "#C85704"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.367617 22.8984L0.0906677 35.8006C2.40784 35.3441 4.78964 35.1764 7.15298 35.0088C9.76557 34.8318 12.4059 34.6548 15 35.0088V22.9077H0.376851L0.367617 22.8984Z",
    fill: "#E68C03"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4668 28.8695C12.1806 28.9719 11.8575 28.9533 11.5621 28.7484C11.3405 28.59 11.3036 26.9877 11.4882 26.494C11.6267 26.1213 11.8575 25.7021 12.3006 25.6556C12.8453 25.5997 13.1038 26.112 13.1684 26.5778C13.1868 26.6803 13.1868 26.8014 13.1961 26.9225C13.3253 27.3044 13.3438 27.7143 13.1961 28.1056C13.1038 28.3571 12.9376 28.5714 12.7437 28.7204C12.6791 28.8043 12.5868 28.8601 12.4668 28.8695Z",
    fill: "#C85704"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0387 31.7661C12.7618 31.9711 12.4294 31.8034 12.3002 31.5332C12.2356 31.4121 12.2079 31.2817 12.1894 31.1513C12.0879 31.0581 12.0325 30.9184 12.0602 30.7414C12.1248 30.3967 12.3002 30.108 12.6048 29.931C12.8449 29.7819 13.1033 29.8285 13.288 30.0521C13.7311 30.5831 13.5834 31.3749 13.048 31.7661H13.0387Z",
    fill: "#C85704"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7789 29.0837C11.0189 29.326 11.0466 29.7731 10.6312 29.8756C10.1142 30.006 9.57878 29.5495 9.85574 28.9999C10.0773 28.5434 10.6774 28.7204 10.7789 29.0931V29.0837Z",
    fill: "#C85704"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.1313 17.0479C3.42672 17.1224 3.7406 17.0665 4.01755 16.8243C4.22065 16.6473 4.08218 15.045 3.85138 14.5792C3.67598 14.2252 3.39902 13.834 2.9559 13.834C2.40199 13.834 2.20812 14.3743 2.18966 14.8401C2.18966 14.9425 2.18966 15.0637 2.19889 15.1941C2.11581 15.5853 2.13427 16.0045 2.3189 16.3678C2.43892 16.61 2.62356 16.8057 2.83589 16.9268C2.90974 17.0013 3.01129 17.0479 3.1313 17.0479Z",
    fill: "#FED6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.88254 20.0018C3.17796 20.1788 3.49184 19.9738 3.59339 19.6851C3.63955 19.5546 3.65801 19.4242 3.66724 19.2938C3.75956 19.1913 3.80572 19.0423 3.75033 18.8746C3.64878 18.5392 3.44568 18.2691 3.12257 18.1293C2.86408 18.0082 2.61482 18.0828 2.45788 18.325C2.07938 18.9026 2.31017 19.6758 2.88254 20.0018Z",
    fill: "#FED6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.82935 17.0858C4.61702 17.356 4.63549 17.7938 5.06015 17.8497C5.58636 17.9149 6.07564 17.4119 5.7433 16.8902C5.47558 16.4617 4.89398 16.7039 4.82935 17.0858Z",
    fill: "#FED6D6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopsicle);
export default __webpack_public_path__ + "static/media/popsicle.12ba50acf1d2b08ff0b0368662f876e8.svg";
export { ForwardRef as ReactComponent };